var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-menu',{attrs:{"offset-y":"","tile":""},scopedSlots:_vm._u([{key:"activator",fn:function(bind){return [_vm._t("activator",null,null,bind)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{staticClass:"a-menu"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }